import React from 'react';
import {CartCheckoutButton, CartCost, useCart} from '@shopify/hydrogen';
import {useCartUI} from './CartUIProvider.client';
import clsx from 'clsx';

//components
import CartSummaryAndDiscounts from './CartSummaryAndDiscounts.client';

export default function CartSummary() {
  const {closeCart} = useCartUI();
  const {totalQuantity} = useCart();
  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <div className="sticky bottom-0">
      <div className="relative flex flex-col">
        <div className="text-[20px] font-normal text-hk-orange">
          {totalQuantity} item{totalQuantity > 1 && 's'} in your shopping cart
        </div>
        <div className="my-[16px] border-t-4 border-black"></div>
        <CartSummaryAndDiscounts isLoading={isLoading} setIsLoading={setIsLoading}/>

        <div className="grid w-full gap-2">
          {/* <CartShopPayButton
              className={clsx([defaultButtonStyles({tone: 'shopPay'}), 'w-1/2'])}
              width="100%"
            /> */}
          <button
            className="disabled:opacty-20 w-full rounded-sm bg-black py-2 text-md text-white transition-all duration-200 ease-out hover:bg-hk-orange hover:text-black"
            onClick={closeCart}
          >
            Continue Shopping
          </button>
          <CartCheckoutButton
            className={clsx([
              'disabled:opacty-20 w-full rounded-sm bg-hk-orange py-2 text-md text-black transition-all duration-200 ease-out hover:bg-black hover:text-white',
            ])}
          >
            Proceed To Checkout
          </CartCheckoutButton>
        </div>
      </div>
    </div>
  );
}

{
  /* <div
              role="row"
              className="flex justify-between border-t border-gray p-4"
            >
              <span className="text-darkGray" role="rowheader">
                Shipping
              </span>
              <span role="cell" className="font-bold uppercase">
                Free
              </span>
            </div> */
}
